/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Form, Input, Icon, Button } from 'antd';
import { navigate } from '@reach/router';
import FloatingCard from '~components/FloatingCard';

function Search() {
  return (
    <FloatingCard.Centered>
      <span
        css={css`
          padding: 0.8rem 0;
        `}
      >
        What equipment are you working on?
      </span>
      <SearchForm />
    </FloatingCard.Centered>
  );
}

const SearchForm = Form.create({ name: 'search' })(({ form }) => {
  const { getFieldDecorator, validateFields } = form;

  const handleSubmit = event => {
    event.preventDefault();
    validateFields((validateErr, { nai }) => {
      if (!validateErr) {
        navigate(`/overview/nai/${nai}`);
      }
    });
  };

  const formStyle = css`
    width: 16rem;
    padding: 0.5rem;
  `;

  const formItemStyle = css`
    margin-bottom: 1rem;
  `;

  return (
    <Form css={formStyle} onSubmit={handleSubmit}>
      <Form.Item css={formItemStyle}>
        {getFieldDecorator('nai', {
          getValueFromEvent: ({ target: { value } = {} }) => {
            return !!value?.toUpperCase ? value.toUpperCase().trim() : value;
          },
          rules: [
            { required: true, message: 'NAI must not be empty' },
            { pattern: /^[\w-]+$/, message: 'No special characters allowed' },
          ],
        })(<Input prefix={<Icon type="search" />} placeholder="NAI/Tail" />)}
      </Form.Item>
      <Form.Item css={formItemStyle}>
        <Button type="primary" htmlType="submit">
          Search
        </Button>
      </Form.Item>
    </Form>
  );
});

export default Search;
